module.exports = __webpack_public_path__ + "static/model-g-spray.2b8b6ab1ea517773284438be65516f74.svg";